import React, { lazy } from 'react';
import { FadeIn } from './ui/FadeIn';
export function TransformationSection() {
  return <section className="py-24 bg-charcoal text-beige relative overflow-hidden" data-id="element-235">
      <div className="container mx-auto px-6 max-w-6xl" data-id="element-236">
        <div className="flex flex-col lg:flex-row items-center gap-16" data-id="element-237">
          <div className="w-full lg:w-1/2" data-id="element-238">
            <FadeIn data-id="element-239">
              <h2 className="font-heading text-4xl md:text-5xl text-beige-light mb-10" data-id="element-240">
                Imagina cómo se sentiría tu vida sin ese peso.
              </h2>
            </FadeIn>

            <div className="space-y-8" data-id="element-241">
              <FadeIn delay={0.2} data-id="element-242">
                <div className="border-l-2 border-terracotta/50 pl-6" data-id="element-243">
                  <h3 className="font-heading text-2xl text-terracotta mb-2" data-id="element-244">
                    Antes
                  </h3>
                  <p className="font-body text-beige/70" data-id="element-245">
                    Sintiendo que nadas contra la corriente. Repitiendo
                    historias dolorosas, sintiendo culpa por querer más, y
                    cargando una tristeza o ansiedad que no logras explicar.
                  </p>
                </div>
              </FadeIn>

              <FadeIn delay={0.4} data-id="element-246">
                <div className="border-l-2 border-gold pl-6" data-id="element-247">
                  <h3 className="font-heading text-2xl text-gold mb-2" data-id="element-248">
                    Después
                  </h3>
                  <p className="font-body text-beige/90" data-id="element-249">
                    Ligera. Libre. Tomando decisiones desde tu propia verdad y
                    no desde el trauma heredado. Atrayendo relaciones sanas y
                    permitiéndote brillar y prosperar sin culpa, sabiendo que al
                    sanar tú, sanas a todo tu linaje.
                  </p>
                </div>
              </FadeIn>
            </div>
          </div>

          <div className="w-full lg:w-1/2" data-id="element-250">
            <FadeIn direction="left" data-id="element-251">
              <div className="relative rounded-sm overflow-hidden shadow-2xl aspect-[4/5] max-w-md mx-auto" data-id="element-252">
                <div className="absolute inset-0 bg-gradient-to-t from-charcoal via-transparent to-transparent z-10 opacity-60" data-id="element-253" />
                <img src="https://cdn.magicpatterns.com/uploads/q1gCBbVPVuLuv39VnR86aR/810d787f-3730-4a10-9b45-8e96d55e3c13.png" alt="Mariposa emergiendo, simbolizando transformación" className="w-full h-full object-cover" loading="lazy" data-id="element-254" />
              </div>
            </FadeIn>
          </div>
        </div>
      </div>
    </section>;
}